<template>
    <Dialog :header="getDialogHeader()" v-model:visible="this.accountEntryDialog" :modal="true" :closable="false" :style="{'max-width': '600px', width: '90%'}">
        <div class="grid">
            <div class="col-12">
                <div class="card">
                    <div class="col-12 md:col-12">
                        <div style="margin-bottom: 1rem;">
                            <h5 v-if="isPurchase"><b>{{ getPurchaseTitle() }}</b></h5>
                            <h5 v-else><b>{{ getSaleTitle() }}</b></h5>
                        </div>
                        <div v-if="isPurchase" class="field grid">
                            <label class="col-12 mb-2 md:col-4 md:mb-0"><b>{{ (data.vendorName !== null) ? "Proveedor:" : "Referencia:" }}</b></label>
                            <div class="col-12 md:col-8">
                                <label>{{ (data.vendorName !== null) ? data.vendorName : data.reason }}</label>
                            </div>
                        </div>
                        <div v-else class="field grid">
                            <label class="col-12 mb-2 md:col-4 md:mb-0"><b>Cliente:</b></label>
                            <div class="col-12 md:col-8">
                                <label>{{ data.customer.name }}</label>
                            </div>
                        </div>
                        <div v-if="data && data.paymentMethod" class="field grid">
                            <label class="col-12 mb-2 md:col-4 md:mb-0"><b>Método de pago:</b></label>
                            <div class="col-12 md:col-8">
                                <label>{{ data.paymentMethod.name }}</label>
                            </div>
                        </div>
                        <div class="field grid" style="margin-bottom: 0rem;">
                            <label class="col-12 mb-2 md:col-4 md:mb-0"><b>Total:</b></label>
                            <div class="col-12 md:col-8">
                                <label>${{ formatTotal(data.total) }}</label>
                            </div>
                        </div>
                        <!-- Notas de crédito del cliente: pagan una parte, se cobra el resto -->
                        <div v-if="!isPurchase && data.creditNoteAmount" class="field grid" style="margin-bottom: 0rem;">
                            <label class="col-12 mb-2 md:col-4 md:mb-0"><b>Nota de crédito:</b></label>
                            <div class="col-12 md:col-8">
                                <label>−${{ data.creditNoteAmount.toFixed(2) }} · por cobrar ${{ getTotalAsNumber().toFixed(2) }}</label>
                            </div>
                        </div>

                        <!-- Desglose de retenciones para compras -->
                        <div v-if="isPurchase && data.hasRetention">
                            <div class="field grid" style="margin-bottom: 0rem; margin-top: 0.5rem; padding-top: 0.5rem; border-top: 1px solid #dee2e6;">
                                <label class="col-12 mb-2 md:col-4 md:mb-0">Retención RENTA:</label>
                                <div class="col-12 md:col-8">
                                    <label style="color: #dc3545;">- ${{ formatTotal(data.rentRetentionValue) }}</label>
                                </div>
                            </div>
                            <div class="field grid" style="margin-bottom: 0rem;">
                                <label class="col-12 mb-2 md:col-4 md:mb-0">Retención IVA:</label>
                                <div class="col-12 md:col-8">
                                    <label style="color: #dc3545;">- ${{ formatTotal(data.ivaRetentionValue) }}</label>
                                </div>
                            </div>
                            <div class="field grid" style="margin-bottom: 0rem; margin-top: 0.5rem; padding-top: 0.5rem; border-top: 1px solid #dee2e6;">
                                <label class="col-12 mb-2 md:col-4 md:mb-0"><b>Valor a Pagar:</b></label>
                                <div class="col-12 md:col-8">
                                    <label style="color: #28a745; font-weight: bold;">${{ formatTotal(data.netPayable) }}</label>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Información adicional para modo múltiple -->
                        <div v-if="isMultipleMode">
                            <div class="field grid" style="margin-bottom: 0rem;">
                                <label class="col-12 mb-2 md:col-4 md:mb-0"><b>Pagado:</b></label>
                                <div class="col-12 md:col-8">
                                    <label class="paid-amount amount-display">${{ totalPaid.toFixed(2) }}</label>
                                </div>
                            </div>
                            <div class="field grid" style="margin-bottom: 0rem;">
                                <label class="col-12 mb-2 md:col-4 md:mb-0"><b>Restante:</b></label>
                                <div class="col-12 md:col-8">
                                    <label :class="{'remaining-amount': true, 'remaining-zero': remainingAmount === 0, 'amount-display': true}">${{ remainingAmount.toFixed(2) }}</label>
                                </div>
                            </div>
                        </div>

                        <!-- Información adicional para modo abono -->
                        <div v-if="isPartialMode">
                            <!-- Sin esta línea el usuario no puede cuadrar la resta:
                                 Total − Retenido − Abonado = Saldo pendiente. -->
                            <div v-if="partialRetained > 0" class="field grid" style="margin-bottom: 0rem; margin-top: 0.5rem; padding-top: 0.5rem; border-top: 1px solid #dee2e6;">
                                <label class="col-12 mb-2 md:col-4 md:mb-0">Retenido:</label>
                                <div class="col-12 md:col-8">
                                    <label style="color: #dc3545;">- ${{ partialRetained.toFixed(2) }}</label>
                                </div>
                            </div>
                            <div class="field grid" style="margin-bottom: 0rem; margin-top: 0.5rem; padding-top: 0.5rem; border-top: 1px solid #dee2e6;">
                                <label class="col-12 mb-2 md:col-4 md:mb-0"><b>Abonado:</b></label>
                                <div class="col-12 md:col-8">
                                    <label class="paid-amount amount-display">${{ partialPaid.toFixed(2) }}</label>
                                </div>
                            </div>
                            <div class="field grid" style="margin-bottom: 0rem;">
                                <label class="col-12 mb-2 md:col-4 md:mb-0"><b>Saldo pendiente:</b></label>
                                <div class="col-12 md:col-8">
                                    <label :class="{'remaining-amount': true, 'remaining-zero': partialPending === 0, 'amount-display': true}">${{ partialPending.toFixed(2) }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card" style="margin-bottom: 0rem;">
                    <div class="col-12 md:col-12">
                        <!-- Método de pago (modo múltiple y abono) -->
                        <div v-if="isMultipleMode || (isPartialMode && hasAccountability)" class="field grid">
                            <label class="col-12 mb-2 md:col-4 md:mb-0"><b>Método de pago:</b></label>
                            <div class="col-12 md:col-8">
                                <Dropdown v-model="currentPaymentMethod" :options="availablePaymentMethods" optionLabel="name" placeholder="-- Seleccione método --" @change="onPaymentMethodChanged" />
                            </div>
                        </div>

                        <!-- Cuenta destino/origen (en abonos solo si hay contabilidad automática) -->
                        <div v-if="!isPartialMode || hasAccountability" class="field grid">
                            <label class="col-12 mb-2 md:col-4 md:mb-0"><b>{{ isPurchase ? 'Cuenta origen:' : 'Cuenta destino:' }}</b></label>
                            <div class="col-12 md:col-8">
                                <Dropdown v-model="selectedAccount" :options="finantialAccounts" optionLabel="name" placeholder="-- Seleccione cuenta --" @change="onSelectedAccountChanged" />
                                <small v-if="noAccountsNotice" class="p-error block mt-2">{{ noAccountsNotice }}</small>
                            </div>
                        </div>

                        <!-- Monto del abono (solo modo abono; sin propina ni cambio) -->
                        <div v-if="isPartialMode" class="field grid">
                            <label class="col-12 mb-2 md:col-4 md:mb-0"><b>Monto del abono:</b></label>
                            <div class="col-12 md:col-8">
                                <InputNumber
                                    v-model="inputAmount"
                                    mode="currency"
                                    currency="USD"
                                    locale="en-US"
                                    :min="0.01"
                                    :max="partialPending"
                                    @focus="selectAllIfZero('inputAmount')"
                                />
                                <small class="text-muted">Máximo: ${{ partialPending.toFixed(2) }} (abonar el saldo completo marca el documento como {{ isPurchase ? 'pagado' : 'cobrado' }})</small>
                            </div>
                        </div>

                        <!-- Campo de propina (solo para SALES, no para purchases ni abonos) -->
                        <div v-if="!isPurchase && !isPartialMode" class="field grid">
                            <label class="col-12 mb-2 md:col-4 md:mb-0"><b>Propina:</b></label>
                            <div class="col-12 md:col-8">
                                <InputNumber 
                                    ref="tipInput"
                                    v-model="tip" 
                                    mode="currency" 
                                    currency="USD" 
                                    locale="en-US" 
                                    :min="0"
                                    @input="calculateTotals"
                                    @focus="selectAllIfZero('tip')"
                                />
                                <!-- Sugerencia 2: Si hay exceso en valor recibido, sugerir como propina -->
                                <div v-if="suggestedTipFromExcess > 0" style="margin-top: 0.5rem;">
                                    <Chip 
                                        :label="`Sugerencia: $${suggestedTipFromExcess.toFixed(2)}`" 
                                        icon="pi pi-lightbulb" 
                                        class="suggestion-chip"
                                        @click="applyTipSuggestion"
                                    />
                                    <small class="text-muted" style="display: block; margin-top: 0.25rem;">
                                        Click para aplicar la diferencia como propina
                                    </small>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Campo para valor recibido/pagado (solo para CASH) -->
                        <div v-if="!isPartialMode && data && data.paymentMethod && data.paymentMethod.code === 'CASH'" class="field grid">
                            <label class="col-12 mb-2 md:col-4 md:mb-0">
                                <b>{{ isPurchase ? 'Valor pagado:' : 'Valor recibido:' }}</b>
                            </label>
                            <div class="col-12 md:col-8">
                                <InputNumber 
                                    ref="inputAmountCash"
                                    v-model="inputAmount" 
                                    mode="currency" 
                                    currency="USD" 
                                    locale="en-US" 
                                    :min="totalWithTip" 
                                    @input="calculateTotals"
                                    @focus="selectAllIfZero('inputAmount')"
                                />
                            </div>
                        </div>
                        
                        <!-- Mostrar cambio sugerido (solo para CASH y solo para VENTAS, no para compras) -->
                        <div v-if="!isPartialMode && !isPurchase && data && data.paymentMethod && data.paymentMethod.code === 'CASH'" class="field grid">
                            <label class="col-12 mb-2 md:col-4 md:mb-0"><b>Cambio a entregar:</b></label>
                            <div class="col-12 md:col-8">
                                <div class="change-display" :class="{'change-zero': change === 0, 'change-negative': change < 0}">
                                    ${{ change.toFixed(2) }}
                                </div>
                            </div>
                        </div>
                        
                        <!-- Valor ingreso/pagar (para otros métodos) -->
                        <div v-if="!isPartialMode && data && data.paymentMethod && data.paymentMethod.code !== 'CASH'" class="field grid">
                            <label class="col-12 mb-2 md:col-4 md:mb-0"><b>{{ isPurchase ? 'Valor a pagar:' : 'Valor ingreso:' }}</b></label>
                            <div class="col-12 md:col-8">
                                <InputNumber 
                                    ref="inputAmountOther"
                                    v-model="inputAmount" 
                                    mode="currency" 
                                    currency="USD" 
                                    locale="en-US" 
                                    :min="0.01"
                                    @focus="selectAllIfZero('inputAmount')"
                                />
                                <!-- Sugerencia 1: Si hay propina, sugerir total + propina -->
                                <div v-if="shouldShowAmountSuggestion" style="margin-top: 0.5rem;">
                                    <Chip 
                                        :label="`Sugerencia: $${totalWithTip.toFixed(2)}`" 
                                        icon="pi pi-lightbulb" 
                                        class="suggestion-chip"
                                        @click="applyAmountSuggestion"
                                    />
                                    <small class="text-muted" style="display: block; margin-top: 0.25rem;">
                                        Click para aplicar total + propina
                                    </small>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Número de aprobación (para tarjetas) -->
                        <div v-if="shouldShowApprovalNumber" class="field grid">
                            <label class="col-12 mb-2 md:col-4 md:mb-0"><b>Nº Aprobación:</b></label>
                            <div class="col-12 md:col-8">
                                <InputText v-model="approvalNumber" placeholder="Número de aprobación del voucher" />
                            </div>
                        </div>
                        
                        <!-- Comprobante (para transferencias y cheques): mismo adjunto que el cobro de mesas -->
                        <div v-if="shouldShowProofUpload" class="field grid" style="margin-bottom: 0rem;">
                            <label class="col-12 mb-2 md:col-4 md:mb-0"><b>Comprobante:</b></label>
                            <div class="col-12 md:col-8">
                                <ProofUpload v-model="selectedProof" label="Seleccionar o tomar foto del comprobante" />
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- Lista de abonos ya registrados (solo modo abono, read-only) -->
                <div v-if="isPartialMode && previousPayments.length > 0" class="card" style="margin-top: 1rem;">
                    <div class="col-12 md:col-12">
                        <h5 style="margin-bottom: 1rem;"><b>Abonos registrados:</b></h5>
                        <div v-for="payment in previousPayments" :key="payment.id" class="payment-item">
                            <div class="payment-info">
                                <div class="payment-amount">${{ formatTotal(payment.amount) }}</div>
                                <div class="payment-details">
                                    <span>{{ formatPaymentDate(payment.createdAt) }}</span>
                                    <span v-if="payment.accountName" class="payment-separator">•</span>
                                    <span v-if="payment.accountName" class="payment-account">{{ payment.accountName }}</span>
                                    <span v-if="payment.paymentMethod" class="payment-separator">•</span>
                                    <span v-if="payment.paymentMethod" class="payment-method">{{ paymentMethodLabel(payment.paymentMethod) }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Lista de pagos agregados (solo modo múltiple) -->
                <div v-if="isMultipleMode && transactions.length > 0" class="card" style="margin-top: 1rem;">
                    <div class="col-12 md:col-12">
                        <h5 style="margin-bottom: 1rem;"><b>Pagos registrados:</b></h5>
                        <div v-for="transaction in transactions" :key="transaction.id" class="payment-item">
                            <div class="payment-info">
                                <div class="payment-amount">${{ transaction.amount.toFixed(2) }}</div>
                                <div class="payment-details">
                                    <span class="payment-method">{{ transaction.paymentMethodName }}</span>
                                    <span class="payment-separator">•</span>
                                    <span class="payment-account">{{ transaction.accountName }}</span>
                                    <span v-if="transaction.tip > 0" class="payment-tip">(incl. propina: ${{ transaction.tip.toFixed(2) }})</span>
                                </div>
                            </div>
                            <Button icon="pi pi-times" class="p-button-rounded p-button-danger p-button-text" @click="removePayment(transaction.id)" />
                        </div>
                        
                        <!-- Mensaje de advertencia si solo hay 1 transacción y el restante es 0 -->
                        <div v-if="transactions.length === 1 && remainingAmount === 0" class="warning-message" style="margin-top: 1rem; padding: 0.75rem; background-color: #fff3cd; border-left: 4px solid #ffc107; border-radius: 4px;">
                            <i class="pi pi-exclamation-triangle" style="color: #856404; margin-right: 0.5rem;"></i>
                            <span style="color: #856404; font-size: 0.9rem;">Debe agregar al menos 2 pagos para usar el método de pago Mixto. Sugerimos cancele esta transacción y seleccione el método correcto en la venta.</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <div style="padding-top: 1rem;">
                <Button label="Cancelar" class="localButton p-button-raised p-button-secondary" style="margin-left: auto;" @click="$emit('onCancel')"/>
                
                <!-- Botones para modo simple -->
                <Button v-if="!isMultipleMode && !isPartialMode" label="Guardar" class="localButton p-button-raised p-button-success" style="margin-left: 0.5rem;"  @click="this.onSave" :disabled="!!noAccountsNotice" />

                <!-- Botón para modo abono -->
                <Button v-if="isPartialMode" label="Abonar" icon="pi pi-wallet" class="localButton p-button-raised p-button-success" style="margin-left: 0.5rem;" @click="onSavePartial" :disabled="!!noAccountsNotice" />

                <!-- Botones para modo múltiple -->
                <Button v-if="isMultipleMode" label="Agregar Pago" icon="pi pi-plus" class="localButton p-button-raised p-button-primary" style="margin-left: 0.5rem;" @click="addPayment" :disabled="remainingAmount === 0 || !!noAccountsNotice" />
                <Button v-if="isMultipleMode" label="Finalizar" icon="pi pi-check" class="localButton p-button-raised p-button-success" style="margin-left: 0.5rem;" @click="onFinalize" :disabled="!canFinalize" />
            </div>
        </template>
    </Dialog>
</template>

<script>
    import { resolveSimpleEntry, resolveMultiplePayment, resolvePartialEntry, noAccountsMessage } from './accountEntryRules';
    import { PAY_METHODS, methodLabel, moneyTypeFor, isCard, takesProof } from '../../service/paymentRules';
    import ProofUpload from './ProofUpload.vue';

    export default {
        components: { ProofUpload },
        data() {
            return {
                selectedAccount: null,
                inputAmount: null,
                selectedProof: null,
                change: 0,
                tip: 0,
                approvalNumber: '',

                // Flags para ocultar sugerencias después de aplicarlas
                hideTipSuggestion: false,
                hideAmountSuggestion: false,

                // Flags para detectar si el cambio viene de una sugerencia
                applyingSuggestion: false,

                // Modo múltiple
                transactions: [], // Array de transacciones agregadas
                currentPaymentMethod: null, // Método actual seleccionado
            }
        },
        props: ['data', 'isVisible', 'mode', 'transactionType'], // transactionType: 'sale' o 'purchase'
        computed: {
            isPurchase() {
                return this.transactionType === 'purchase';
            },
            isSale() {
                return this.transactionType === 'sale';
            },
            accountEntryDialog() {
                return this.isVisible;
            },
            moneyType() {
                // Tipo de cuenta (FinantialAccount.moneyType) compatible con la forma de pago activa,
                // para que el dropdown solo ofrezca cuentas compatibles (regla compartida con mesas).
                return moneyTypeFor(this.activeMethodCode);
            },
            finantialAccounts() {
                if (!this.$store.getters.finantialAccounts) return [];
                return this.$store.getters.finantialAccounts.filter((a) => a.moneyType === this.moneyType);
            },
            // Sin cuenta que elegir el cobro no se puede guardar (H36). Solo cuando el diálogo
            // pide cuenta: un abono sin contabilidad automática no la lleva.
            noAccountsNotice() {
                if (this.isPartialMode && !this.hasAccountability) return null;
                const typed = this.activeMethodCode ? this.moneyType : null;
                return noAccountsMessage(this.$store.getters.finantialAccounts, typed);
            },
            totalWithTip() {
                const total = this.getTotalAsNumber();
                // Las compras no tienen propina
                if (this.isPurchase) {
                    return total;
                }
                const tipAmount = this.tip || 0;
                return total + tipAmount;
            },
            // Sugerencia 2: Calcular exceso para propina (si valor recibido > total venta sin propina)
            // Solo aplica para ventas, no para compras
            suggestedTipFromExcess() {
                if (this.isPurchase) return 0; // Las compras no tienen propina
                if (this.hideTipSuggestion) return 0; // Ocultar si ya se aplicó
                if (!this.inputAmount || this.inputAmount <= 0) return 0;
                const totalVenta = this.getTotalAsNumber();
                const excess = this.inputAmount - totalVenta;
                // Solo sugerir si hay exceso y no hay propina ya ingresada (o es 0)
                if (excess > 0 && (this.tip === 0 || this.tip === null)) {
                    return excess;
                }
                return 0;
            },
            // Mostrar sugerencia de amount solo si no se ha ocultado
            shouldShowAmountSuggestion() {
                if (this.isPurchase) return false; // Las compras no tienen propina
                if (!this.data || !this.data.paymentMethod) return false;
                return !this.hideAmountSuggestion && this.tip > 0 && this.data.paymentMethod.code === 'TRANSFER';
            },
            // Modo múltiple: Calcular monto restante
            remainingAmount() {
                if (this.mode !== 'multiple') return 0;

                const total = this.getTotalAsNumber();
                const paid = this.transactions.reduce((sum, t) => sum + (t.amount || 0), 0);
                // Cuantizar a centavos antes de devolver: la suma de floats
                // arrastra error de IEEE-754 (p. ej. 100.10 - 33.37 - 33.37
                // - 33.36 = 1.06e-14, no 0). Sin esto, `remainingAmount === 0`
                // queda en false aunque el usuario haya cubierto el total y
                // los botones "Finalizar" / "Agregar Pago" se quedan en un
                // estado inválido. Math.round((x)*100)/100 colapsa cualquier
                // residuo sub-centavo a 0 exacto.
                const remaining = Math.round((total - paid) * 100) / 100;
                return Math.max(0, remaining);
            },
            // Modo múltiple: Total pagado
            totalPaid() {
                return this.transactions.reduce((sum, t) => sum + (t.amount || 0), 0);
            },
            // Modo múltiple: Verificar si se puede finalizar
            canFinalize() {
                if (this.mode !== 'multiple') return true;
                // Requerir al menos 2 transacciones y que el restante sea 0
                return this.remainingAmount === 0 && this.transactions.length >= 2;
            },
            // Determinar si está en modo múltiple
            isMultipleMode() {
                return this.mode === 'multiple';
            },
            // Determinar si está en modo abono (pago parcial)
            isPartialMode() {
                return this.mode === 'partial';
            },
            // Método de pago activo según el modo: en múltiple y abono lo
            // elige el usuario en el dropdown; en simple viene del documento.
            activeMethodCode() {
                if (this.isMultipleMode || this.isPartialMode) {
                    return this.currentPaymentMethod ? this.currentPaymentMethod.code : null;
                }
                return this.data && this.data.paymentMethod ? this.data.paymentMethod.code : null;
            },
            // ¿El negocio registra movimientos en cuentas? (misma fuente que
            // saleForm/purchaseForm). En abonos sin contabilidad se registra
            // solo el Payment, sin cuenta ni método.
            hasAccountability() {
                const user = this.$store.getters.getUser;
                const flag = user
                    && user.settings
                    && user.settings.settings
                    && user.settings.settings.account_enableAutoTransactions;
                return !!(flag && flag.value);
            },
            // Modo abono: total ya abonado y saldo pendiente (vienen del
            // backend en el serializer del documento; fallback al total).
            partialPaid() {
                if (!this.data || this.data.paidAmount === undefined || this.data.paidAmount === null) return 0;
                return Number(this.data.paidAmount.toString());
            },
            // Modo abono: retención ya aplicada al documento (0 en ventas y en
            // compras sin retención). Solo informativa: el saldo ya viene neto.
            partialRetained() {
                if (!this.data || this.data.retainedAmount === undefined || this.data.retainedAmount === null) return 0;
                return Number(this.data.retainedAmount.toString());
            },
            partialPending() {
                if (this.data && this.data.pendingAmount !== undefined && this.data.pendingAmount !== null) {
                    return Number(this.data.pendingAmount.toString());
                }
                const pending = Math.round((this.getTotalAsNumber() - this.partialPaid) * 100) / 100;
                return Math.max(0, pending);
            },
            // Modo abono: abonos ya registrados (read-only, del serializer).
            previousPayments() {
                return (this.data && this.data.payments) ? this.data.payments : [];
            },
            // Métodos de pago disponibles (excluye MIXED en múltiple y abono)
            availablePaymentMethods() {
                if (!this.isMultipleMode && !this.isPartialMode) return [];
                return PAY_METHODS.map((m) => ({ name: m.label, code: m.value }));
            },
            // Mostrar campo de número de aprobación (tarjetas)
            shouldShowApprovalNumber() {
                return isCard(this.activeMethodCode);
            },
            // Mostrar campo de comprobante (transferencia y cheque)
            shouldShowProofUpload() {
                return takesProof(this.activeMethodCode);
            },
            // Single source of truth para "¿esta venta/compra exige adjuntar
            // comprobante en pagos por transferencia o cheque?"
            //
            // La fuente correcta es userextension.settings — es la que vive
            // en el endpoint /login y la que el resto del dashboard ya usa.
            // `business.defaults` está DEPRECIATED (se mantiene en el modelo
            // por compatibilidad pero NO se sincroniza con la UI; leerlo
            // produce el bug histórico de que el modo simple y el modo
            // múltiple tomaban valores distintos del mismo flag).
            requiresProofForTransactions() {
                const user = this.$store.getters.getUser;
                const flag = user
                    && user.settings
                    && user.settings.settings
                    && user.settings.settings.account_mustAttachtProofInTransactions;
                return !!(flag && flag.value);
            }
        },
        watch: {
            'data.total': {
                immediate: true,
                handler(newVal) {
                    if (newVal && this.inputAmount === null) {
                        // Inicializar con lo que hay que cobrar (sin propina aún): el
                        // total menos las notas de crédito aplicadas. En modo abono se
                        // inicializa con el saldo pendiente.
                        this.inputAmount = this.isPartialMode ? this.partialPending : this.getTotalAsNumber();
                        this.calculateTotals();
                    }
                }
            },
            finantialAccounts: {
                immediate: true,
                handler(accounts) {
                    // Resetear la cuenta seleccionada cuando cambian las cuentas disponibles
                    this.selectedAccount = null;
                    
                    // Auto-seleccionar solo para CASH
                    if (accounts && accounts.length > 0 && this.moneyType === "CASH") {
                        this.selectedAccount = accounts[0];
                    }
                }
            },
            moneyType() {
                // Resetear cuenta seleccionada cuando cambia el tipo de dinero
                this.selectedAccount = null;
            },
            inputAmount(newVal, oldVal) {
                this.calculateTotals();
                // Solo resetear flags si NO viene de una sugerencia
                if (!this.applyingSuggestion && oldVal !== null && newVal !== oldVal) {
                    this.hideTipSuggestion = false;
                    this.hideAmountSuggestion = false;
                }
            },
            tip(newVal, oldVal) {
                this.calculateTotals();
                // Solo resetear flags si NO viene de una sugerencia
                if (!this.applyingSuggestion && oldVal !== null && newVal !== oldVal) {
                    this.hideTipSuggestion = false;
                    this.hideAmountSuggestion = false;
                }
            },
            // Watcher para modos múltiple/abono: inicializar al abrir el dialog
            isVisible: {
                immediate: true,
                handler(newVal) {
                    if (newVal && this.mode === 'multiple') {
                        // Limpiar transacciones previas
                        this.transactions = [];
                        // Inicializar inputAmount con el total
                        this.inputAmount = this.remainingAmount > 0 ? this.remainingAmount : this.getTotalAsNumber();
                    }
                    if (newVal && this.mode === 'partial') {
                        // Prellenar con el saldo pendiente y limpiar el resto
                        this.currentPaymentMethod = null;
                        this.selectedAccount = null;
                        this.approvalNumber = '';
                        this.selectedProof = null;
                        this.tip = 0;
                        this.inputAmount = this.partialPending;
                    }
                }
            }
        }, 
        methods: {
            getDialogHeader() {
                if (this.isPartialMode) {
                    return this.isPurchase ? 'Abono a compra' : 'Abono a venta';
                }
                if (this.isPurchase) {
                    return this.isMultipleMode ? 'Salida de caja (Pago múltiple)' : 'Salida de caja';
                } else {
                    return this.isMultipleMode ? 'Ingreso de caja (Pago múltiple)' : 'Ingreso de caja';
                }
            },
            formatPaymentDate(rawDate) {
                if (!rawDate) return '';
                const date = new Date(rawDate.toString().replace(' ', 'T'));
                if (isNaN(date.getTime())) return rawDate.toString();
                return date.toLocaleDateString('es-EC', { year: 'numeric', month: 'short', day: 'numeric' });
            },
            paymentMethodLabel(code) {
                return methodLabel(code);
            },
            onSelectedAccountChanged(event) {
                this.selectedAccount = event.value;
            },
            getPurchaseTitle() {
                if (!this.data) return "Nueva Compra";
                
                // Si tiene edoc, mostrar comprobante
                if (this.data.edoc !== null && this.data.edoc !== undefined) {
                    return "Comprobante: " + this.data.edoc.sequence;
                }
                
                // Si tiene ID, mostrarlo formateado
                if (this.data.id !== null && this.data.id !== undefined) {
                    return "Compra: " + this.data.id.toString().padStart(8, "0");
                }
                
                // Si no tiene ID (nueva compra), mostrar genérico
                return "Nueva Compra";
            },
            getSaleTitle() {
                if (!this.data) return "Nueva Venta";
                
                // Si tiene edoc, mostrar factura
                if (this.data.edoc !== null && this.data.edoc !== undefined) {
                    return "Factura: " + this.data.edoc.sequence;
                }
                
                // Si tiene ID, mostrarlo formateado
                if (this.data.id !== null && this.data.id !== undefined) {
                    return "Venta: " + this.data.id.toString().padStart(8, "0");
                }
                
                // Si no tiene ID (nueva venta), mostrar genérico
                return "Nueva Venta";
            },
            getTotalAsNumber() {
                if (!this.data) return 0;
                
                // Para compras con retención, usar el valor neto a pagar (total - retenciones)
                if (this.isPurchase && this.data.hasRetention && this.data.netPayable) {
                    const netPayable = this.data.netPayable;
                    return typeof netPayable === 'number' ? netPayable : Number(netPayable.toString());
                }
                
                // Para ventas o compras sin retención, usar el total normal
                if (!this.data.total) return 0;
                const total = typeof this.data.total === 'number' ? this.data.total : Number(this.data.total.toString());
                // Venta con notas de crédito del cliente: esa parte ya está pagada
                // con su saldo a favor, se cobra solo el resto.
                if (!this.isPurchase && this.data.creditNoteAmount) {
                    return Math.max(0, Math.round((total - this.data.creditNoteAmount) * 100) / 100);
                }
                return total;
            },
            formatTotal(total) {
                if (!total) return '0.00';
                const num = typeof total === 'number' ? total : Number(total.toString());
                return num.toFixed(2);
            },
            calculateTotals() {
                // Calcular cambio: valor recibido - total venta - propina
                const totalVenta = this.getTotalAsNumber();
                const propina = this.tip || 0;
                const valorRecibido = this.inputAmount || 0;
                
                // Siempre calcular el cambio, incluso si es negativo o cero
                this.change = valorRecibido - totalVenta - propina;
            },
            selectAllIfZero(field) {
                // Verificar si el campo es 0 y limpiarlo
                if (field === 'tip') {
                    if (this.tip === 0 || this.tip === null) {
                        this.tip = null;
                    }
                } else if (field === 'inputAmount') {
                    if (this.inputAmount === 0 || this.inputAmount === null) {
                        this.inputAmount = null;
                    }
                }
            },
            // Aplicar sugerencia 1: Total + Propina en Valor ingreso
            applyAmountSuggestion() {
                this.applyingSuggestion = true; // Marcar que viene de sugerencia
                this.inputAmount = this.totalWithTip;
                this.hideAmountSuggestion = true; // Ocultar después de aplicar
                this.$nextTick(() => {
                    this.applyingSuggestion = false; // Resetear después del ciclo
                });
            },
            // Aplicar sugerencia 2: Diferencia como propina
            applyTipSuggestion() {
                this.applyingSuggestion = true; // Marcar que viene de sugerencia
                this.tip = this.suggestedTipFromExcess;
                this.hideTipSuggestion = true; // Ocultar después de aplicar
                // IMPORTANTE: También ocultar la sugerencia de amount para evitar que aparezca
                this.hideAmountSuggestion = true;
                this.$nextTick(() => {
                    this.applyingSuggestion = false; // Resetear después del ciclo
                });
            },
            // Traduce el código de error de las reglas puras a un mensaje claro.
            moneyErrorMessage(res, paymentCode) {
                const totalAPagar = this.getTotalAsNumber() + (this.isPurchase ? 0 : (this.tip || 0));
                switch (res.error) {
                    case 'amount-required':
                        return "El valor de ingreso tiene que ser mayor a cero";
                    case 'cash-insufficient':
                        return this.isPurchase
                            ? "El valor recibido no puede ser menor al total a pagar"
                            : "El valor recibido no puede ser menor al total a pagar (venta + propina)";
                    case 'excess-must-be-tip':
                        return this.isPurchase
                            ? `El valor no puede exceder el total a pagar ($${this.getTotalAsNumber().toFixed(2)}).`
                            : `No se puede dar cambio con ${this.paymentMethodWord(paymentCode)}. El excedente de $${res.excess.toFixed(2)} debe registrarse como propina (use la sugerencia o ingréselo en el campo Propina).`;
                    case 'amount-mismatch':
                        return `El valor ingresado debe ser igual al total a pagar ($${totalAPagar.toFixed(2)}).`;
                    default:
                        return "Valor de ingreso inválido";
                }
            },
            paymentMethodWord(code) {
                if (code === 'TRANSFER') return 'transferencia';
                if (code === 'CHECK') return 'cheque';
                if (code === 'DEBIT_CARD' || code === 'CREDIT_CARD') return 'tarjeta';
                return 'este método de pago';
            },
            checkForm() {
                const paymentCode = (this.data && this.data.paymentMethod) ? this.data.paymentMethod.code : null;

                // Validación de cuenta destino
                if (this.selectedAccount === null || this.selectedAccount === undefined) {
                    return "Seleccione una cuenta de destino"
                }

                // Reglas de dinero (amount/propina/cambio) delegadas al módulo puro.
                const res = resolveSimpleEntry({
                    total: this.getTotalAsNumber(),
                    paymentCode,
                    inputAmount: this.inputAmount,
                    tip: this.tip,
                    isPurchase: this.isPurchase,
                });
                if (!res.ok) {
                    return this.moneyErrorMessage(res, paymentCode);
                }

                // Validaciones específicas por método de pago (comprobante / voucher)
                if (paymentCode === 'TRANSFER' || paymentCode === 'CHECK') {
                    if (this.requiresProofForTransactions && (this.selectedProof === null || this.selectedProof === undefined)) {
                        const docType = paymentCode === 'CHECK' ? 'cheque' : 'transferencia';
                        return `Debe adjuntar el comprobante de ${docType}`;
                    }
                } else if (paymentCode === 'DEBIT_CARD' || paymentCode === 'CREDIT_CARD') {
                    if (this.approvalNumber === null || this.approvalNumber === '') {
                        return "Ingrese el número de aprobación del voucher"
                    }
                }

                return null;
            },
            onSave() {
                // Verificar errores de validación
                const error = this.checkForm();

                if (error !== null) {
                    // Mostrar error con Toast pero NO cerrar el dialog
                    this.$toast.add({severity:'error', summary: 'Error de validación', detail: error, life: 4000});
                    return; // Salir sin continuar
                }

                // NO crear transacciones aquí, solo capturar y emitir los datos
                // El componente padre (saleForm/purchaseForm) se encargará de:
                // 1. Guardar/Archivar/Facturar el documento
                // 2. Crear las transacciones con el ID real y referencias correctas
                
                this.$emit('onSave', {
                    accountId: this.selectedAccount.id,
                    accountName: this.selectedAccount.name,
                    // `amount` es el monto APLICADO al documento (== total de la
                    // venta/compra), SIN la propina. La propina viaja en su propia
                    // columna (`tip`) y NO participa en el balance de la cuenta.
                    // El backend valida `Σ amount == sale.total`; si aquí mandáramos
                    // total+propina, el batch rechazaría el cobro con 422 cuando
                    // hay propina. El padre aplicará el signo correcto.
                    amount: this.getTotalAsNumber(),
                    tip: this.isPurchase ? 0 : (this.tip || 0), // Las compras no tienen propina
                    approvalNumber: this.approvalNumber || null,
                    proof: this.selectedProof || null,
                    paymentMethod: this.data && this.data.paymentMethod ? this.data.paymentMethod.code : null
                });
            },

            // ========== Métodos para modo abono (partial) ==========

            checkPartialForm() {
                // Con contabilidad automática el abono debe reportar a una
                // cuenta; sin ella solo se registra el monto.
                if (this.hasAccountability) {
                    if (!this.currentPaymentMethod || !this.currentPaymentMethod.code) {
                        return "Seleccione un método de pago";
                    }
                    if (this.selectedAccount === null || this.selectedAccount === undefined) {
                        return this.isPurchase ? "Seleccione una cuenta de origen" : "Seleccione una cuenta de destino";
                    }

                    const paymentCode = this.currentPaymentMethod.code;
                    if (paymentCode === 'TRANSFER' || paymentCode === 'CHECK') {
                        if (this.requiresProofForTransactions && (this.selectedProof === null || this.selectedProof === undefined)) {
                            const docType = paymentCode === 'CHECK' ? 'cheque' : 'transferencia';
                            return `Debe adjuntar el comprobante de ${docType}`;
                        }
                    } else if (paymentCode === 'DEBIT_CARD' || paymentCode === 'CREDIT_CARD') {
                        if (this.approvalNumber === null || this.approvalNumber === '') {
                            return "Ingrese el número de aprobación del voucher";
                        }
                    }
                }

                const res = resolvePartialEntry({
                    pending: this.partialPending,
                    inputAmount: this.inputAmount,
                });
                if (!res.ok) {
                    if (res.error === 'exceeds-pending') {
                        return `El abono ($${(this.inputAmount || 0).toFixed(2)}) no puede exceder el saldo pendiente ($${this.partialPending.toFixed(2)}).`;
                    }
                    if (res.error === 'nothing-pending') {
                        return "Este documento no tiene saldo pendiente por abonar.";
                    }
                    return "El monto del abono tiene que ser mayor a cero";
                }

                return null;
            },

            onSavePartial() {
                const error = this.checkPartialForm();
                if (error !== null) {
                    this.$toast.add({severity:'error', summary: 'Error de validación', detail: error, life: 4000});
                    return;
                }

                const res = resolvePartialEntry({
                    pending: this.partialPending,
                    inputAmount: this.inputAmount,
                });

                // El padre registra el abono contra el endpoint
                // `registerPayment` (los abonos no llevan propina).
                this.$emit('onSave', {
                    partial: true,
                    amount: res.amount,
                    completes: res.completes,
                    accountId: this.hasAccountability && this.selectedAccount ? this.selectedAccount.id : null,
                    paymentMethod: this.hasAccountability && this.currentPaymentMethod ? this.currentPaymentMethod.code : null,
                    approvalNumber: this.approvalNumber || null,
                    proof: this.selectedProof || null,
                });
            },

            // ========== Métodos para modo múltiple ==========
            
            addPayment() {
                // Validar el pago actual antes de agregarlo
                const error = this.checkCurrentPaymentForm();
                if (error) {
                    this.$toast.add({severity:'error', summary: 'Error de validación', detail: error, life: 4000});
                    return;
                }
                
                // Reglas del pago mixto (módulo puro):
                //  - `amount` (monto aplicado) va contra el restante del total.
                //  - `tip` es ADITIVA y vive en su propio campo: NO reduce el
                //    restante ni infla el monto aplicado, por lo que ingresar
                //    propina ya NO dispara la falsa alerta de "excede el restante".
                //  - Si el monto aplicado supera el restante → se bloquea con un
                //    mensaje claro (el batch backend exige Σ amount == total).
                const res = resolveMultiplePayment({
                    remaining: this.remainingAmount,
                    inputAmount: this.inputAmount,
                    tip: this.tip,
                    isPurchase: this.isPurchase,
                });
                if (!res.ok) {
                    if (res.error === 'exceeds-remaining') {
                        const docType = this.isPurchase ? 'compra' : 'venta';
                        this.$toast.add({
                            severity:'error',
                            summary: 'Monto excede el restante',
                            detail: `El monto aplicado ($${(this.inputAmount || 0).toFixed(2)}) no puede exceder el restante de la ${docType} ($${this.remainingAmount.toFixed(2)}).` + (this.isPurchase ? '' : ' La propina se ingresa en su propio campo, aparte del monto.'),
                            life: 5000
                        });
                    } else {
                        this.$toast.add({severity:'error', summary: 'Monto inválido', detail: 'El monto debe ser mayor a cero.', life: 4000});
                    }
                    return;
                }

                // Crear objeto de transacción capturada (sin referencia, el padre la construirá)
                const transaction = {
                    id: Date.now(), // ID temporal para el array local
                    accountId: this.selectedAccount.id,
                    accountName: this.selectedAccount.name,
                    amount: res.amount,
                    paymentMethod: this.currentPaymentMethod ? this.currentPaymentMethod.code : ((this.data && this.data.paymentMethod) ? this.data.paymentMethod.code : null),
                    paymentMethodName: this.currentPaymentMethod ? this.currentPaymentMethod.name : ((this.data && this.data.paymentMethod) ? this.data.paymentMethod.name : null),
                    moneyType: this.moneyType,
                    tip: res.tip, // Las compras no tienen propina (0 garantizado por la regla)
                    approvalNumber: this.approvalNumber || null,
                    proof: this.selectedProof || null
                };
                
                // Agregar a la lista
                this.transactions.push(transaction);
                
                // Limpiar formulario para el siguiente pago
                this.resetFormFields();
                
                // Mostrar mensaje de éxito
                this.$toast.add({severity:'success', summary: 'Pago agregado', detail: `Se agregó pago de $${transaction.amount.toFixed(2)}`, life: 2000});
            },
            
            removePayment(transactionId) {
                const transaction = this.transactions.find(t => t.id === transactionId);
                if (transaction) {
                    this.transactions = this.transactions.filter(t => t.id !== transactionId);
                    this.$toast.add({severity:'info', summary: 'Pago eliminado', detail: `Se eliminó pago de $${transaction.amount.toFixed(2)}`, life: 2000});
                }
            },
            
            onPaymentMethodChanged(event) {
                this.currentPaymentMethod = event.value;
                // Resetear la cuenta seleccionada cuando cambia el método de pago
                this.selectedAccount = null;
            },
            
            resetFormFields() {
                this.currentPaymentMethod = null; // Resetear método de pago en modo múltiple
                this.selectedAccount = null;
                this.inputAmount = this.remainingAmount; // Auto-llenar con lo que falta
                this.tip = 0;
                this.approvalNumber = '';
                this.selectedProof = null;
                this.change = 0;
                
                // Resetear flags de sugerencias
                this.hideTipSuggestion = false;
                this.hideAmountSuggestion = false;
            },
            
            checkCurrentPaymentForm() {
                // En modo múltiple, validar que se haya seleccionado un método de pago
                if (this.isMultipleMode && (!this.currentPaymentMethod || !this.currentPaymentMethod.code)) {
                    return "Seleccione un método de pago";
                }
                
                // Validar cuenta seleccionada
                if (this.selectedAccount === null || this.selectedAccount === undefined) {
                    return "Seleccione una cuenta de destino";
                }
                
                // Validar monto
                if (this.inputAmount === null || this.inputAmount === "" || this.inputAmount <= 0) {
                    return "El valor de ingreso tiene que ser mayor a cero";
                }
                
                // Obtener el método de pago actual
                const paymentCode = this.currentPaymentMethod ? this.currentPaymentMethod.code : this.data.paymentMethod.code;
                
                // Validaciones específicas por método de pago
                if (paymentCode === 'TRANSFER' || paymentCode === 'CHECK') {
                    // Verificar si requiere comprobante (misma fuente de verdad que el modo simple)
                    if (this.requiresProofForTransactions && (this.selectedProof === null || this.selectedProof === undefined)) {
                        const docType = paymentCode === 'CHECK' ? 'cheque' : 'transferencia';
                        return `Debe adjuntar el comprobante de ${docType}`;
                    }
                } else if (paymentCode === 'DEBIT_CARD' || paymentCode === 'CREDIT_CARD') {
                    // Tarjetas: Número de aprobación requerido
                    if (this.approvalNumber === null || this.approvalNumber === '') {
                        return "Ingrese el número de aprobación del voucher";
                    }
                }
                
                return null;
            },
            
            onFinalize() {
                if (!this.canFinalize) {
                    // Determinar el motivo específico del error
                    const docType = this.isPurchase ? 'compra' : 'venta';
                    
                    if (this.transactions.length === 0) {
                        this.$toast.add({
                            severity:'error', 
                            summary: 'Sin pagos', 
                            detail: 'Debe agregar al menos un pago antes de finalizar', 
                            life: 4000
                        });
                    } else if (this.transactions.length < 2) {
                        this.$toast.add({
                            severity:'error', 
                            summary: 'Pagos insuficientes', 
                            detail: `Debe agregar al menos 2 pagos para usar el método MIXTO. Si solo usa un método de pago, selecciónelo directamente en la ${docType}.`, 
                            life: 6000
                        });
                    } else if (this.remainingAmount > 0) {
                        this.$toast.add({
                            severity:'error', 
                            summary: 'Pago incompleto', 
                            detail: `Falta por pagar: $${this.remainingAmount.toFixed(2)}. Agregue más pagos para completar el total.`, 
                            life: 5000
                        });
                    }
                    return;
                }
                
                // Guardia: propina digitada pero no agregada a ningún pago.
                // Sin esto se perdería en silencio al finalizar.
                if (!this.isPurchase && this.tip > 0) {
                    this.$toast.add({
                        severity:'error',
                        summary: 'Propina sin asignar',
                        detail: `Tiene una propina de $${this.tip.toFixed(2)} sin agregar a ningún pago. Elimine el último pago y vuelva a agregarlo incluyendo la propina, o borre el valor del campo Propina.`,
                        life: 6000
                    });
                    return;
                }

                // Calcular propina total (solo para ventas, compras siempre tienen tip=0)
                const totalTip = this.transactions.reduce((sum, t) => sum + (t.tip || 0), 0);
                
                // Emitir todas las transacciones capturadas al padre
                // El padre se encargará de crear el documento y luego las transacciones con referencias correctas
                this.$emit('onSave', {
                    transactions: this.transactions,
                    totalTip: totalTip
                });
            }
        },
    }
</script>
<style scoped lang="scss">

@media screen and (max-width: 769px) {
    .localButton {
        width: 100%
    }
}
@media screen and (min-width: 769px) {
    .localButton {
        width: auto;
    }
}

.total-display {
    font-size: 1.5rem;
    font-weight: 700;
    color: #3b82f6;
    padding: 0.5rem;
    background-color: #eff6ff;
    border-radius: 6px;
    text-align: center;
}

.change-display {
    font-size: 1.5rem;
    font-weight: 700;
    color: #22c55e;
    padding: 0.5rem;
    background-color: #f0fdf4;
    border-radius: 6px;
    text-align: center;
}

.change-zero {
    color: #6b7280;
    background-color: #f3f4f6;
}

.change-negative {
    color: #ef4444;
    background-color: #fef2f2;
}

.suggestion-chip {
    cursor: pointer;
    background-color: #fef3c7 !important;
    color: #92400e !important;
    
    &:hover {
        background-color: #fde68a !important;
    }
}

.text-muted {
    color: var(--text-color-secondary);
    font-size: 0.875rem;
    display: block;
    margin-top: 0.25rem;
}

/* Estilos para modo múltiple */
.amount-display {
    font-size: 1.25rem;
    font-weight: 700;
}

.paid-amount {
    color: #10b981;
}

.remaining-amount {
    color: #f59e0b;
}

.remaining-zero {
    color: #10b981;
}

.payment-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem;
    margin-bottom: 0.5rem;
    background-color: #f9fafb;
    border-radius: 8px;
    border-left: 4px solid #3b82f6;
}

.payment-info {
    flex: 1;
}

.payment-amount {
    font-size: 1.25rem;
    font-weight: 700;
    color: #1f2937;
    margin-bottom: 0.25rem;
}

.payment-details {
    font-size: 0.875rem;
    color: #6b7280;
}

.payment-method {
    font-weight: 600;
    color: #4b5563;
}

.payment-separator {
    margin: 0 0.5rem;
}

.payment-account {
    color: #6b7280;
}

.payment-tip {
    margin-left: 0.5rem;
    color: #10b981;
    font-style: italic;
}
</style>